<template>
  <div>
       <ServerError v-if="ServerError" />

    <v-snackbar v-model="showSnackBar" color="#FC4B4B" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #ffffff">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap justify-center px-3>
      <v-flex xs12 sm6 pt-10>
        <v-card>
          <v-layout wrap justify-center text-left py-5 pa-6>
            <v-flex xs12 text-center pt-3 pb-5>
              <span
                class="sofiaPro"
                style="
                  font-size: 20px;
                  padding-bottom: 8px;
                  border-bottom: 2px solid #0000001c;
                "
                >Upload Documents</span
              >
            </v-flex>
            <!-- <v-flex xs12>
              <v-card outlined tile height="200px">
                <v-layout wrap justify-center fill-height text-center>
                  <v-flex xs12 align-self-center>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-icon
                          large
                          color="#408BFF"
                          @click="$refs.files.click()"
                          >mdi-cloud-upload</v-icon
                        >
                      </v-flex>
                      <v-flex xs12>
                        <span class="sofiaPro">Upload Company Documents</span>
                      </v-flex>
                      <v-flex xs12>
                        <span
                          class="sofialight"
                          style="font-size: 12px; color: grey"
                          >Jpg or PDF</span
                        >
                      </v-flex>
                      <input
                        v-show="false"
                        id="file1"
                        ref="files"
                        type="file"
                        multiple
                        @change="browsedocs"
                      />
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex> -->
            <v-flex xs12>
              <v-chip
                v-for="(item, i) in docsname"
                :key="i"
                class="ma-2"
                color="red"
                text-color="white"
              >
                <span v-if="item">
                  {{ item }}
                  &nbsp;
                  <span v-if="item.split('.').pop() == 'pdf'">
                    <a target="_blank" :href="baseURL + '/file/get/' + item">
                      <v-btn dark rounded outlined x-small>
                        View
                      </v-btn></a
                    ></span
                  >
                  <span v-else>
                    <v-btn
                      @click="(doc = item), (dialog = true)"
                      dark
                      rounded
                      outlined
                      x-small
                    >
                      View
                    </v-btn>
                  </span>
                </span>

                <!-- <v-btn dark rounded outlined x-small>
                  View
                </v-btn> -->
              </v-chip>
            </v-flex>
            <v-flex xs12>
              <v-chip
                v-for="(item, i) in docs"
                :key="i"
                class="ma-2"
                close
                color="red"
                text-color="white"
                @click:close="remove(i)"
              >
                {{ item.name }}
              </v-chip>
            </v-flex>
            <!-- <v-flex xs12>
              <v-btn dark block color="#E31E24" @click="adddocument">
                Submit
              </v-btn>
            </v-flex> -->
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog persistent v-model="dialog" width="70%">
      <v-card>
        <v-toolbar  dense dark :color="appColor">
          <v-spacer></v-spacer>
          <v-btn right icon dark @click="doc=null,dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-title class="text-h5 grey lighten-2">
          Document
        </v-card-title>

        <!-- <v-card-text v-if="doc.split('.').pop() == 'pdf'">
          <iframe
            v-if="doc"
            :src="baseURL + '/' + doc"
            height="700px"
            width="900px"
            contain
          >
          </iframe>
        </v-card-text> -->
        <v-card-text v-if="doc">
          <v-img :src="mediaURL + doc"></v-img>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            small
            color="red"
            text
            @click="(dialog = false), (doc = null)"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["storage"],
  data() {
    return {
      dialog: false,
      doc: null,
      docsname: [],
      docs: [],
      docs1: [],
      docsdata: new FormData(),
      showSnackBar: false,
      msg: "",
      timeout: 3000,
      bankdata: {
        branch: null,
        accountHolder: null,
        accountNo: null,
        ifsc: null,
        bank: null,
       
      },
      ServerError: null,
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 10 || "Max 10 digits",
      },
    };
  },
  //    computed: {
  //   bankdata() {
  //     if (this.bank) {
  //       return this.bank;
  //     } else return {};
  //   },
  // },
  mounted() {
    this.docsname = this.storage.documents;
  },
  methods: {
    adddocument() {
      for (var i = 0; i < this.docs.length; i++) {
        this.docsdata.append("documents", this.docs[i]);
      }

      axios({
        method: "post",
        url: "seller/profile/level4",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: this.docsdata,
      }).then((response) => {
        if (response.data.status) {
          this.msg = response.data.msg;
          this.showSnackBar = true;
          this.$emit("stepper", {
            level: 4,
          });
        } else {
          this.showSnackBar = true;
          this.msg = response.data.msg;
        }
        this.appLoading = false;
      })
      .catch((err) =>
      {
        console.log(err)
        this.ServerError = true;
      }
      
      );
    },
    browsedocs(event) {
      this.docs1 = event.target.files;
      for (let i = 0; i < this.docs1.length; i++) {
        this.docs.push(this.docs1[i]);
      }

      // console.log("docs issssss", this.docs);
    },
    remove(item) {
      console.log("item", item);
      this.docs.splice(item, 1);

      console.log("removed");
    },
  },
};
</script>
